import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {RefillDTO} from '../models/RefillDTO';

@Injectable({
  providedIn: 'root'
})
export class RefillService {
  private url = environment.baseUrl + '/refill';

  constructor(private httpClient: HttpClient) {
  }

  getListOfRefills(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<RefillDTO>> {
    return this.httpClient.post<PagedResponseDTO<RefillDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveRefill(refillDTO: RefillDTO): Observable<RefillDTO> {
    return this.httpClient.post<RefillDTO>(this.url, refillDTO);
  }

  deleteRefill(refillId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + refillId);
  }

  getRefill(refillId: number): Observable<RefillDTO> {
    return this.httpClient.get<RefillDTO>(this.url + '/' + refillId);
  }
}
